import { CancelRounded, CheckCircleRounded, DeleteRounded } from "@mui/icons-material";
import {
	Box,
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogTitle,
	FormControl,
	FormHelperText,
	IconButton,
	LinearProgress,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";
import { blue, grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { AuthState } from "context/AuthContext";
import { GlobalState } from "context/GlobalContext";
import { PimDashboardState } from "context/PimDashboardContext";
import {
	valueAddTableColumns,
	valueAddConsumptionTableColumns,
	pimConsumpGarmentOptions,
	pimDescCatAssociationObj,
	valueAddRequiredForValues,
	valueAddSourcingValues,
	valueAddConsumptionAssociationObj,
	sendReceiveUnitOptions,
} from "../../data";
import { styleColorAssocObj } from "components/PimDashboard/data";
import { channelTypes } from "components/PimDashboard/DashboardComponents/Buying/BuyingSheet/data";
import { inputTypes } from "data/globalData";
import { useEffect, useState } from "react";

const colStyle = {
	headerAlign: "center",
	align: "center",
};

const RightWrongBox = ({ field, row }) => {
	return (
		<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
			{row[field] === true ? <CheckCircleRounded color="success" /> : <CancelRounded color="error" />}
		</Box>
	);
};
export const WhiteBgBox = ({ field, row }) => {
	return (
		<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center" sx={{ background: "white" }}>
			<span>{row[field]}</span>
		</Box>
	);
};

const ValueAdditionTable = ({ styleValueAddArr, updatedValueAddArr, setUpdatedValueAddArr, publishDisabled, categoryMaster }) => {
	const { setValueAddCatDescObj, valueAddCatDescObj, selectedStyle, placementMaster, setPlacementMaster } = PimDashboardState();
	const { setSnackBar, setSnackBarOpen, snackBar } = GlobalState();
	const { user } = AuthState();
	const defTableColumns = [
		{
			...valueAddTableColumns.category,
			width: 120,
			...colStyle,
			headerName: valueAddTableColumns.category.name,
			field: valueAddTableColumns.category.key,
			renderCell: ({ field, row }) => {
				return (
					<Box component="div" onClick={() => openConsumptionPopup(row)}>
						<span style={{ color: blue[600] }}>{row[field]}</span>
					</Box>
				);
			},
		},
		{
			...valueAddTableColumns.description,
			field: valueAddTableColumns.description.key,
			headerName: valueAddTableColumns.description.name,
			width: 180,
			...colStyle,
		},
		{
			...valueAddTableColumns.placement,
			field: valueAddTableColumns.placement.key,
			headerName: valueAddTableColumns.placement.name,
			width: 180,
			...colStyle,
			type: "singleSelect",
			editable: true,
			valueOptions: [],
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...valueAddTableColumns.send_receive_unit,
			field: valueAddTableColumns.send_receive_unit.key,
			headerName: valueAddTableColumns.send_receive_unit.name,
			width: 180,
			...colStyle,
			type: "singleSelect",
			editable: true,
			valueOptions: [inputTypes.SELECT.key, ...sendReceiveUnitOptions?.map((row) => row?.key)],
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...valueAddTableColumns.color_level,
			width: 100,
			...colStyle,
			headerName: valueAddTableColumns.color_level.name,
			field: valueAddTableColumns.color_level.key,
			renderCell: ({ field, row }) => {
				return <RightWrongBox field={field} row={row} />;
			},
		},
		{
			...valueAddTableColumns.size_level,
			headerName: valueAddTableColumns.size_level.name,
			field: valueAddTableColumns.size_level.key,
			width: 100,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <RightWrongBox field={field} row={row} />;
			},
		},
		{
			...valueAddTableColumns.channel_level,
			headerName: valueAddTableColumns.channel_level.name,
			field: valueAddTableColumns.channel_level.key,
			width: 100,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <RightWrongBox field={field} row={row} />;
			},
		},

		// {
		// 	...valueAddTableColumns.consumption,
		// 	field: valueAddTableColumns.consumption.key,
		// 	headerName: valueAddTableColumns.consumption.name,
		// 	width: 120,
		// 	...colStyle,
		// 	editable: true,
		// 	renderCell: ({ field, row }) => {
		// 		return <WhiteBgBox field={field} row={row} />;
		// 	},
		// },
		{
			...valueAddTableColumns.consumption_unit,
			field: valueAddTableColumns.consumption_unit.key,
			headerName: valueAddTableColumns.consumption_unit.name,
			width: 120,
			...colStyle,
		},
		{
			...valueAddTableColumns.per_garment_qty,
			field: valueAddTableColumns.per_garment_qty.key,
			headerName: valueAddTableColumns.per_garment_qty.name,
			width: 120,
			editable: true,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},

		// {
		// 	...valueAddTableColumns.wastage_percent,
		// 	field: valueAddTableColumns.wastage_percent.key,
		// 	headerName: valueAddTableColumns.wastage_percent.name,
		// 	width: 120,
		// 	...colStyle,
		// 	renderCell: ({ field, row }) => {
		// 		return <WhiteBgBox field={field} row={row} />;
		// 	},
		// 	editable: true,
		// },
		// {
		// 	...valueAddTableColumns.req_for,
		// 	field: valueAddTableColumns.req_for.key,
		// 	headerName: valueAddTableColumns.req_for.name,
		// 	width: 120,
		// 	...colStyle,
		// 	renderCell: ({ field, row }) => {
		// 		return <WhiteBgBox field={field} row={row} />;
		// 	},
		// 	editable: true,
		// 	type: "singleSelect",
		// 	valueOptions: [inputTypes.SELECT.key, ...Object.keys(valueAddRequiredForValues)],
		// },
		// {
		// 	...valueAddTableColumns.sourcing,
		// 	field: valueAddTableColumns.sourcing.key,
		// 	headerName: valueAddTableColumns.sourcing.name,
		// 	width: 120,
		// 	...colStyle,
		// 	renderCell: ({ field, row }) => {
		// 		return <WhiteBgBox field={field} row={row} />;
		// 	},
		// 	editable: true,
		// 	type: "singleSelect",
		// 	valueOptions: [inputTypes.SELECT, ...Object.keys(valueAddSourcingValues)],
		// },
		{
			...valueAddTableColumns.price,
			field: valueAddTableColumns.price.key,
			headerName: valueAddTableColumns.price.name,
			width: 120,
			...colStyle,
		},
		{
			...valueAddTableColumns.price_currency,
			field: valueAddTableColumns.price_currency.key,
			headerName: valueAddTableColumns.price_currency.name,
			width: 120,
			...colStyle,
		},
		{
			headerName: "Delete",
			width: 120,
			...colStyle,
			renderCell: ({ row }) => {
				return (
					<IconButton onClick={() => handleDeleteValueAddClick(row)} disabled={publishDisabled}>
						<DeleteRounded />
					</IconButton>
				);
			},
		},
	];

	const defvalueAddConsumptionColumns = [
		{
			...valueAddConsumptionTableColumns.category,
			width: 120,
			...colStyle,
			headerName: valueAddConsumptionTableColumns.category.name,
			field: valueAddConsumptionTableColumns.category.key,
		},
		{
			...valueAddConsumptionTableColumns.description,
			field: valueAddConsumptionTableColumns.description.key,
			headerName: valueAddConsumptionTableColumns.description.name,
			width: 180,
			...colStyle,
		},
		{
			...valueAddTableColumns.placement,
			field: valueAddTableColumns.placement.key,
			headerName: valueAddTableColumns.placement.name,
			width: 180,
			...colStyle,
		},
		{
			...valueAddTableColumns.send_receive_unit,
			field: valueAddTableColumns.send_receive_unit.key,
			headerName: valueAddTableColumns.send_receive_unit.name,
			width: 180,
			...colStyle,
		},
		{
			...valueAddConsumptionTableColumns.gar_color,
			width: 100,
			...colStyle,
			headerName: valueAddConsumptionTableColumns.gar_color.name,
			field: valueAddConsumptionTableColumns.gar_color.key,
		},
		{
			...valueAddConsumptionTableColumns.item_color,
			headerName: valueAddConsumptionTableColumns.item_color.name,
			field: valueAddConsumptionTableColumns.item_color.key,
			width: 100,
			...colStyle,
			editable: true,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...valueAddConsumptionTableColumns.gar_size,
			width: 100,
			...colStyle,
			headerName: valueAddConsumptionTableColumns.gar_size.name,
			field: valueAddConsumptionTableColumns.gar_size.key,
		},
		{
			...valueAddConsumptionTableColumns.item_size,
			headerName: valueAddConsumptionTableColumns.item_size.name,
			field: valueAddConsumptionTableColumns.item_size.key,
			width: 100,
			...colStyle,
			editable: true,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...valueAddConsumptionTableColumns.gar_channel,
			headerName: valueAddConsumptionTableColumns.gar_channel.name,
			field: valueAddConsumptionTableColumns.gar_channel.key,
			width: 100,
			...colStyle,
		},
		{
			...valueAddConsumptionTableColumns.item_channel,
			headerName: valueAddConsumptionTableColumns.item_channel.name,
			field: valueAddConsumptionTableColumns.item_channel.key,
			width: 100,
			...colStyle,
			editable: true,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		// {
		// 	...valueAddConsumptionTableColumns.consumption,
		// 	headerName: valueAddConsumptionTableColumns.consumption.name,
		// 	field: valueAddConsumptionTableColumns.consumption.key,
		// 	width: 120,
		// 	...colStyle,
		// 	editable: true,
		// 	renderCell: ({ field, row }) => {
		// 		return <WhiteBgBox field={field} row={row} />;
		// 	},
		// },
		{
			...valueAddConsumptionTableColumns.consumption_unit,
			field: valueAddConsumptionTableColumns.consumption_unit.key,
			headerName: valueAddConsumptionTableColumns.consumption_unit.name,
			width: 120,
			...colStyle,
		},
		{
			...valueAddConsumptionTableColumns.per_garment_qty,
			field: valueAddConsumptionTableColumns.per_garment_qty.key,
			headerName: valueAddConsumptionTableColumns.per_garment_qty.name,
			width: 120,
			editable: true,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},

		// {
		// 	...valueAddConsumptionTableColumns.wastage_percent,
		// 	field: valueAddConsumptionTableColumns.wastage_percent.key,
		// 	headerName: valueAddConsumptionTableColumns.wastage_percent.name,
		// 	width: 120,
		// 	...colStyle,
		// 	renderCell: ({ field, row }) => {
		// 		return <WhiteBgBox field={field} row={row} />;
		// 	},
		// 	editable: true,
		// },
		// {
		// 	...valueAddConsumptionTableColumns.req_for,
		// 	field: valueAddConsumptionTableColumns.req_for.key,
		// 	headerName: valueAddConsumptionTableColumns.req_for.name,
		// 	width: 120,
		// 	...colStyle,
		// },
		// {
		// 	...valueAddConsumptionTableColumns.sourcing,
		// 	field: valueAddConsumptionTableColumns.sourcing.key,
		// 	headerName: valueAddConsumptionTableColumns.sourcing.name,
		// 	width: 120,
		// 	...colStyle,
		// },
		{
			...valueAddConsumptionTableColumns.price,
			field: valueAddConsumptionTableColumns.price.key,
			headerName: valueAddConsumptionTableColumns.price.name,
			width: 120,
			...colStyle,
		},
		{
			...valueAddConsumptionTableColumns.price_currency,
			field: valueAddConsumptionTableColumns.price_currency.key,
			headerName: valueAddConsumptionTableColumns.price_currency.name,
			width: 120,
			...colStyle,
		},
	];
	const [valueAddColumns, setValueAddColumns] = useState(defTableColumns);
	const [valueAddArr, setValueAddArr] = useState(styleValueAddArr?.length ? styleValueAddArr : []);
	const [valueAddConsumptionColumns, setValueAddConsumptionColumns] = useState(defvalueAddConsumptionColumns);

	const defTrimGroupObj = Object.keys(valueAddTableColumns).reduce((acc, row) => {
		acc[valueAddTableColumns[row].key] = valueAddTableColumns[row]?.defaultValue;
		return acc;
	}, {});
	const [trimToAdd, setTrimToAdd] = useState(defTrimGroupObj);
	// for select Input
	const [selectedTrimCategoryDesc, setSelectedTrimCategoryDesc] = useState();
	// const [catDescArr, setCatDescArr] = useState();
	const [consumptionPopup, setConsumptionPopup] = useState(false);
	const [selectedTrim, setSelectedTrim] = useState();
	const [descriptionLoad, setDescriptionLoad] = useState(false);

	console.log(updatedValueAddArr, "updatedValueAddArr");

	useEffect(() => {
		const fetch = async () => {
			try {
				const res = await axios.get("/api/master/get_value_add_placement_master");
				setPlacementMaster(res.data);
				console.log(res.data, "ewhjfdgvuweifk");

				setValueAddColumns([
					...defTableColumns?.map((row) => {
						if (row?.field === "placement")
							return {
								...row,
								valueOptions: [inputTypes.SELECT.key, ...new Set(res?.data ? res.data?.map((row) => row?.name) : [])],
							};
						else return row;
					}),
				]);
			} catch (error) {
				console.log(error);
				console.log("unable to get fabric data");
			}
		};
		if (!placementMaster && placementMaster?.length !== 0) fetch();
		else {
			setValueAddColumns([
				...defTableColumns?.map((row) => {
					if (row?.field === "placement")
						return {
							...row,
							valueOptions: [
								inputTypes.SELECT.key,
								...new Set(placementMaster ? placementMaster?.map((row) => row?.name) : []),
							],
						};
					else return row;
				}),
			]);
		}
	}, [placementMaster]);

	const handleConsumptionPopupClose = () => {
		setConsumptionPopup(false);
	};

	const updateTrimDetailsToConsumptionRows = (trimObj, consumptionArr) => {
		return consumptionArr?.map((row) => {
			row[valueAddConsumptionTableColumns.category.key] = trimObj[valueAddConsumptionTableColumns.category.key];
			row[valueAddConsumptionTableColumns.description.key] = trimObj[valueAddConsumptionTableColumns.description.key];
			row[valueAddConsumptionTableColumns.placement.key] = trimObj[valueAddConsumptionTableColumns.placement.key];
			row[valueAddConsumptionTableColumns.send_receive_unit.key] =
				trimObj[valueAddConsumptionTableColumns.send_receive_unit.key];
			// row[valueAddConsumptionTableColumns.consumption.key] = trimObj[valueAddConsumptionTableColumns.consumption.key];
			row[valueAddConsumptionTableColumns.consumption_unit.key] = trimObj[valueAddConsumptionTableColumns.consumption_unit.key];
			row[valueAddConsumptionTableColumns.per_garment_qty.key] = trimObj[valueAddConsumptionTableColumns.per_garment_qty.key];
			// row[valueAddConsumptionTableColumns.wastage_percent.key] = trimObj[valueAddConsumptionTableColumns.wastage_percent.key];
			// row[valueAddConsumptionTableColumns.req_for.key] = trimObj[valueAddConsumptionTableColumns.req_for.key];
			// row[valueAddConsumptionTableColumns.sourcing.key] = trimObj[valueAddConsumptionTableColumns.sourcing.key];
			row[valueAddConsumptionTableColumns.price.key] = trimObj[valueAddConsumptionTableColumns.price.key];
			row[valueAddConsumptionTableColumns.price_currency.key] = trimObj[valueAddConsumptionTableColumns.price_currency.key];

			return row;
		});
	};

	const handleAddTrimGroup = () => {
		let obj = trimToAdd;
		if (
			!obj ||
			obj[valueAddTableColumns.category.key] === inputTypes.SELECT.key ||
			obj[valueAddTableColumns.description.key] === inputTypes.SELECT.key
		) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Select Details `,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return;
		}
		const colorARR =
			selectedStyle && obj[valueAddTableColumns.color_level.key] === true
				? selectedStyle[styleColorAssocObj]
				: [{ ["color"]: "ALL" }];
		const channelArr =
			obj[valueAddTableColumns.channel_level.key] === true
				? Object.keys(channelTypes)?.map((row) => {
						return { channel: row };
				  })
				: [{ channel: "ALL" }];

		let consumpTableArr = [];
		const defconsumpTableRow = {
			...Object.keys(valueAddConsumptionTableColumns).reduce((acc, row) => {
				acc[row] = valueAddConsumptionTableColumns[row]?.defaultValue;
				return acc;
			}, {}),
			...updateTrimDetailsToConsumptionRows(obj, [{}])[0],
		};
		let no = new Date().valueOf();
		colorARR?.forEach((color) => {
			channelArr?.forEach((channel) => {
				consumpTableArr.push({
					id: ++no,
					is_new: true,
					...defconsumpTableRow,
					[valueAddConsumptionTableColumns.gar_color.key]: color["color"],
					[valueAddConsumptionTableColumns.item_color.key]: color["color"],
					[valueAddConsumptionTableColumns.gar_channel.key]: channel.channel,
					[valueAddConsumptionTableColumns.item_channel.key]: channel.channel,
					[valueAddConsumptionTableColumns.gar_size.key]:
						obj[valueAddTableColumns.size_level.key] === true
							? pimConsumpGarmentOptions.PENDING.key
							: pimConsumpGarmentOptions.ALL.key,
					[valueAddConsumptionTableColumns.item_size.key]:
						obj[valueAddTableColumns.size_level.key] === true
							? pimConsumpGarmentOptions.PENDING.key
							: pimConsumpGarmentOptions.ALL.key,
				});
			});
		});
		let objToAdd = {
			...trimToAdd,
			is_new: true,
			id: new Date().valueOf(),
			[valueAddConsumptionAssociationObj]: consumpTableArr,
		};
		if (valueAddArr?.length >= 0) {
			setValueAddArr([...valueAddArr, objToAdd]);
		} else setValueAddArr([objToAdd]);
		setUpdatedValueAddArr([...updatedValueAddArr, objToAdd]);
		setTrimToAdd(defTrimGroupObj);
	};

	const handleCatgorySelectChange = async (e) => {
		let arr = [];
		setDescriptionLoad(true);
		if (valueAddCatDescObj && valueAddCatDescObj[e.target.value]) {
			arr = valueAddCatDescObj[e.target.value];
			setDescriptionLoad(false);
		} else {
			const res = await axios.get(`/api/master/get_commodity_cat_desc_master?category=${e.target.value}`);
			setValueAddCatDescObj({ ...valueAddCatDescObj, [e.target.value]: res.data });
			arr = res.data;
			setDescriptionLoad(false);
		}

		setSelectedTrimCategoryDesc(arr);

		setTrimToAdd({
			...trimToAdd,
			[valueAddTableColumns.category.key]: e.target.value,
			[valueAddTableColumns.description.key]: inputTypes.SELECT.key,
		});
	};
	function openConsumptionPopup(selectedTrim) {
		setConsumptionPopup(true);
		setSelectedTrim(selectedTrim);
	}
	const handleTrimTableRowUpdate = (updated, old) => {
		let updatedObj = {
			...updated,
			[valueAddConsumptionAssociationObj]: updateTrimDetailsToConsumptionRows(
				updated,
				updated[valueAddConsumptionAssociationObj]
			),
		};
		setValueAddArr(
			valueAddArr?.map((row) => {
				if (row?.id === updated?.id) return updatedObj;
				else return row;
			})
		);
		setUpdatedValueAddArr(
			updatedValueAddArr?.map((row) => {
				if (row?.id === updated?.id) return updatedObj;
				else return row;
			})
		);
		return updatedObj;
	};
	const handleConsumptionTableRowUpdate = (updated, old) => {
		let updatedObj = {
			...selectedTrim,
			[valueAddConsumptionAssociationObj]: selectedTrim[valueAddConsumptionAssociationObj]?.map((row) => {
				if (row?.id === updated?.id) return { ...updated, updated_by: user?.email };
				else return row;
			}),
		};
		setValueAddArr(
			valueAddArr?.map((row) => {
				if (row?.id === updatedObj?.id) return updatedObj;
				else return row;
			})
		);
		setUpdatedValueAddArr([...updatedValueAddArr?.filter((row) => row.id !== updatedObj?.id), updatedObj]);
		return updated;
	};
	const handleDeleteValueAddClick = async (row) => {
		try {
			if (!row.is_new) {
				await axios.delete(`/api/fabric_valueAdd/delete_value_add/${row.id}`).then((res) => {
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: `Fabric Deleted `,
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				});
			} else {
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: `Fabric Deleted `,
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			}
			setValueAddArr(valueAddArr.filter((fab) => fab?.id !== row.id));
			setUpdatedValueAddArr(updatedValueAddArr?.filter((fab) => fab?.id !== row.id));
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Error Occured `,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};
	return (
		<Box pt={2}>
			<Box display="flex" alignItems="center" flexWrap="wrap">
				<Typography pb={0} variant="h6" width="100%">
					Value Addition
				</Typography>
				{/* <Divider orientation="horizontal" variant="fullWidth" /> */}
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Box
						sx={{
							alignSelf: "flex-start",
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							columnGap: 1,
							p: 1,
							// background: grey[200],
							borderRadius: 1,
						}}>
						<FormControl>
							<Select
								sx={{ width: 170 }}
								size="small"
								fullWidth
								variant="outlined"
								MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
								value={
									trimToAdd && trimToAdd[valueAddTableColumns.category.key]
										? trimToAdd[valueAddTableColumns.category.key]
										: inputTypes.SELECT.key
								}
								onChange={(e) => handleCatgorySelectChange(e)}>
								<MenuItem value={inputTypes.SELECT.key}>
									<span style={{ color: grey[400] }}>Select Category</span>
								</MenuItem>
								{categoryMaster?.map((row) => {
									let cat = row[valueAddTableColumns?.category.key] ? row[valueAddTableColumns?.category.key] : "";

									return (
										<MenuItem key={cat} value={cat}>
											{cat}
										</MenuItem>
									);
								})}
							</Select>
							<FormHelperText>
								<LinearProgress sx={{ display: descriptionLoad ? "block" : "none" }} />
							</FormHelperText>
						</FormControl>

						<Select
							sx={{ width: 170 }}
							size="small"
							fullWidth
							variant="outlined"
							MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
							value={
								trimToAdd && trimToAdd[valueAddTableColumns.description.key]
									? trimToAdd[valueAddTableColumns.description.key]
									: inputTypes.SELECT.key
							}
							onChange={(e) => {
								let selectedTrimGrpDesc = selectedTrimCategoryDesc?.filter(
									(row) => row[valueAddTableColumns.description.key] === e.target.value
								);
								if (selectedTrimGrpDesc)
									setTrimToAdd({
										...trimToAdd,
										...selectedTrimGrpDesc[0],
										[valueAddTableColumns.consumption_unit.key]:
											selectedTrimGrpDesc[0][valueAddTableColumns.consumption_unit.sqlCol],
										// [valueAddTableColumns.consumption.key]:selectedTrimGrpDesc[0][valueAddTableColumns.consumption.sqlCol]
									});
							}}>
							<MenuItem value={inputTypes.SELECT.key}>
								<span style={{ color: grey[400] }}>Select Description</span>
							</MenuItem>
							{selectedTrimCategoryDesc?.map((row) => {
								return (
									<MenuItem
										key={row[valueAddTableColumns.description.key]}
										value={row[valueAddTableColumns.description.key]}>
										{row[valueAddTableColumns.description.key]}
									</MenuItem>
								);
							})}
						</Select>
						<Box display="flex" alignItems="center">
							<Checkbox
								checked={trimToAdd && trimToAdd[valueAddTableColumns.color_level.key] === true ? true : false}
								onChange={(e) =>
									setTrimToAdd({
										...trimToAdd,
										[valueAddTableColumns.color_level.key]: e.target.checked ? true : false,
									})
								}
								inputProps={{ "aria-label": "controlled" }}
							/>
							<Typography variant="subtitle1">{valueAddTableColumns.color_level.name}</Typography>
						</Box>
						<Box display="flex" alignItems="center">
							<Checkbox
								checked={trimToAdd && trimToAdd[valueAddTableColumns.size_level.key] === true ? true : false}
								onChange={(e) =>
									setTrimToAdd({
										...trimToAdd,
										[valueAddTableColumns.size_level.key]: e.target.checked ? true : false,
									})
								}
								inputProps={{ "aria-label": "controlled" }}
							/>
							<Typography variant="subtitle1">{valueAddTableColumns.size_level.name}</Typography>
						</Box>
						<Box display="flex" alignItems="center">
							<Checkbox
								checked={trimToAdd && trimToAdd[valueAddTableColumns.channel_level.key] === true ? true : false}
								onChange={(e) =>
									setTrimToAdd({
										...trimToAdd,
										[valueAddTableColumns.channel_level.key]: e.target.checked ? true : false,
									})
								}
								inputProps={{ "aria-label": "controlled" }}
							/>
							<Typography variant="subtitle1">{valueAddTableColumns.channel_level.name}</Typography>
						</Box>
						<Box>
							<Button size="small" variant="contained" onClick={handleAddTrimGroup}>
								Add
							</Button>
						</Box>
					</Box>
				</Box>
			</Box>
			<div width="100%">
				<DataGrid
					columns={valueAddColumns}
					key={valueAddColumns && valueAddArr}
					rows={valueAddArr ? valueAddArr : []}
					slotProps={{
						baseSelect: {
							MenuProps: {
								PaperProps: {
									sx: {
										maxHeight: 220,
										width: 200,
										// overflow: "scroll",
									},
								},
							},
						},
					}}
					sx={{
						height: 220,
						background: grey[200],
						// border: "none",
						"& .MuiDataGrid-row": {
							// borderBottom: "1px solid lightgray",
							cursor: "pointer",
							// border: "none",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
						},
						"& .MuiDataGrid-cell": {
							padding: 0,
						},
						"& .MuiDataGrid-cell:focus-within": {
							outline: `solid`,
						},
						"& .MuiDataGrid-columnHeaders": {
							background: grey[100],
							// mb: 2,
							// border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
					}}
					onCellEditStop={(params, event) => {
						// if (params.reason === GridCellEditStopReasons.) {
						// 	event.defaultMuiPrevented = true;
						// }
					}}
					columnHeaderHeight={35}
					rowHeight={35}
					showCellVerticalBorder
					// onRowClick={(params, e) => {
					// 	onValueAddSelect(params.row);
					// }}
					initialState={{
						pagination: {
							paginationModel: { pageSize: 10 },
						},
					}}
					hideFooter
					disableRowSelectionOnClick
					processRowUpdate={handleTrimTableRowUpdate}
				/>
			</div>

			<Dialog onClose={handleConsumptionPopupClose} open={consumptionPopup} fullWidth maxWidth="lg">
				<DialogTitle>View Consumption</DialogTitle>

				{selectedTrim && (
					<Box spacing={2} padding={2}>
						<DataGrid
							columns={valueAddConsumptionColumns}
							rows={
								selectedTrim[valueAddConsumptionAssociationObj] ? selectedTrim[valueAddConsumptionAssociationObj] : []
							}
							sx={{
								height: 220,
								background: grey[200],
								// border: "none",
								"& .MuiDataGrid-row": {
									// borderBottom: "1px solid lightgray",
									cursor: "pointer",
									// border: "none",
								},
								"& .MuiDataGrid-columnHeader": {
									cursor: "pointer",
								},
								"& .MuiDataGrid-columnHeader": {
									cursor: "pointer",
								},
								"& .MuiDataGrid-cell": {
									padding: 0,
								},
								"& .MuiDataGrid-columnHeaders": {
									background: grey[100],
									// mb: 2,
									// border: "none",
									borderRadius: 1,
									// padding: "10px 0px",
								},
							}}
							onCellEditStop={(params, event) => {
								// if (params.reason === GridCellEditStopReasons.) {
								// 	event.defaultMuiPrevented = true;
								// }
							}}
							columnHeaderHeight={35}
							rowHeight={40}
							showCellVerticalBorder
							initialState={{
								pagination: {
									paginationModel: { pageSize: 10 },
								},
							}}
							hideFooter
							disableRowSelectionOnClick
							processRowUpdate={handleConsumptionTableRowUpdate}
						/>
					</Box>
				)}
				<DialogActions sx={{ pr: 2, pb: 2 }}>
					<Button variant="outlined" onClick={handleConsumptionPopupClose}>
						Close
					</Button>
					{/* <Button variant="contained">Save</Button> */}
				</DialogActions>
			</Dialog>
		</Box>
	);
};

export default ValueAdditionTable;
